







































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import InvestigateApi from '@/api/investigate'
import BillApi from '@/api/bill'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import moment from 'moment'
import RiskApi from '@/api/risk'

@Component({
	name: 'riskTaskList',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	private lossTypeList: any = [
		{ key: '伤残', value: '伤残' },
		{ key: '死亡', value: '死亡' },
		{ key: '小额人伤', value: '小额人伤' },
		{ key: '一般损伤', value: '一般损伤' },
	]

	private nodeList: any = [
		{ key: '人伤查勘审核', value: '人伤查勘审核' },
		{ key: '人伤跟踪', value: '人伤跟踪' },
		{ key: '人伤跟踪审核', value: '人伤跟踪审核' },
		{ key: '人伤核损', value: '人伤核损' },
	]

	private defaultDateRange: any = [
		moment().subtract(7, 'days'),
		moment().startOf('day'),
	]

	private taskDetailPwd(action: any) {
		return `/riskTask/taskDetail/${action.reqId}`
	}

	public getList() {
		return RiskApi.getList(this.getForm()).then((res: any) => {
			this.list = res.data.list
			this.total = res.data.total
			this.resetSelected()
		})
	}

	private disabledDate(current: any) {
		// Can not select days before today and today
		return current && current > moment().endOf('day')
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree')
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.startTime =
			form.rangeTime &&
			form.rangeTime[0] &&
			form.rangeTime[0].format('YYYYMMDD')
		form.endTime =
			form.rangeTime &&
			form.rangeTime[1] &&
			form.rangeTime[1].format('YYYYMMDD')
		form.companyNo = this.$store.state.user.userInfo.companyNo
		delete form.rangeTime

		return form
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
